export const PRODUCT_PAGES: ReadonlyArray<string> = [
  'open-banking',
  'card-payments',
  'card-payouts',
  'checkout',
  'bank-payouts',
  'bank-sign',
  'no-code-payment-page',
  'customer-lifetime-value-prediction',
  'payment-link',
  'qr-code-payments',
  'stream-donations',
];
